import Date, {internalFormat} from './Date'

export { internalFormat }

export default Date
